export default __webpack_public_path__ + "static/media/key-function-template.319613c1.pptx";